import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Copy from organization ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_billing_templates_form_field_template_name = _resolveComponent("billing-templates-form-field-template-name")!
  const _component_billing_templates_form_field_organization_name = _resolveComponent("billing-templates-form-field-organization-name")!
  const _component_billing_templates_form_field_business_id = _resolveComponent("billing-templates-form-field-business-id")!
  const _component_billing_templates_form_field_street = _resolveComponent("billing-templates-form-field-street")!
  const _component_billing_templates_form_field_city = _resolveComponent("billing-templates-form-field-city")!
  const _component_billing_templates_form_field_zip = _resolveComponent("billing-templates-form-field-zip")!
  const _component_billing_templates_form_field_country = _resolveComponent("billing-templates-form-field-country")!
  const _component_billing_templates_form_field_contact_email = _resolveComponent("billing-templates-form-field-contact-email")!
  const _component_billing_templates_form_field_contact_name = _resolveComponent("billing-templates-form-field-contact-name")!
  const _component_billing_templates_form_field_vat_id = _resolveComponent("billing-templates-form-field-vat-id")!
  const _component_billing_templates_form_field_customer_number = _resolveComponent("billing-templates-form-field-customer-number")!
  const _component_billing_templates_form_field_payment_terms = _resolveComponent("billing-templates-form-field-payment-terms")!
  const _component_billing_templates_form_field_reference = _resolveComponent("billing-templates-form-field-reference")!
  const _component_billing_templates_form_field_invoice_description = _resolveComponent("billing-templates-form-field-invoice-description")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_btn, {
      dense: "",
      outlined: "",
      class: "q-px-md",
      color: "primary",
      onClick: _ctx.copyFromOrganization
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.showTemplateName)
      ? (_openBlock(), _createBlock(_component_billing_templates_form_field_template_name, {
          key: 0,
          modelValue: _ctx.localModel.templateName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localModel.templateName) = $event))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_billing_templates_form_field_organization_name, {
      modelValue: _ctx.localModel.organizationName,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localModel.organizationName) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_business_id, {
      modelValue: _ctx.localModel.businessId,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localModel.businessId) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_street, {
      modelValue: _ctx.localModel.street,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localModel.street) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_city, {
      modelValue: _ctx.localModel.city,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localModel.city) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_zip, {
      modelValue: _ctx.localModel.zip,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localModel.zip) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_country, {
      modelValue: _ctx.localModel.countryCode,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localModel.countryCode) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_contact_email, {
      modelValue: _ctx.localModel.contactPersonEmail,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localModel.contactPersonEmail) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_contact_name, {
      modelValue: _ctx.localModel.contactPersonName,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localModel.contactPersonName) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_vat_id, {
      modelValue: _ctx.localModel.vatId,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localModel.vatId) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_customer_number, {
      modelValue: _ctx.localModel.customerNumber,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localModel.customerNumber) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_payment_terms, {
      modelValue: _ctx.localModel.paymentTerms,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.localModel.paymentTerms) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_reference, {
      modelValue: _ctx.localModel.reference,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.localModel.reference) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_billing_templates_form_field_invoice_description, {
      modelValue: _ctx.localModel.invoiceDescription,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.localModel.invoiceDescription) = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}